import Vue from "vue";
import Vuex from "vuex";
import { axios2 as axios } from "@/interceptor/useApi";
import Swal from "sweetalert2";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    Download: {},
    isDownloading: false,
  },
  getters: {
  },
  mutations: {
    LlenarDownload(state, data) {
      state.Download = data;
    },
    SetIsDownloading(state, value) {
      state.isDownloading = value;
    },
  },
  actions: {
    //Datos del cliente con que se inicia sesión
    ObtenerVersionado: async function ({ commit, dispatch }) {
      let url = "app/last/version";
      await axios
        .get(url) // Cambia a `get` porque es una consulta GET para obtener datos.
        .then((response) => {
          const data = response.data.resultado;
          commit("LlenarDownload", {
            text: 'Descargar App',
            icon: 'mdi-download',
            funcion: 'Dowloadapp',
            version: data.version,
            nombreapk: data.nombre
          });
        })
        .catch((error) => {
          commit("LlenarDownload", null);
        });
    },
    DescargarApk: async function ({ state, commit }, nombreapk) {
      // Prevenir doble ejecución o clics múltiples
      if (state.isDownloading) return;
      commit("SetIsDownloading", true);

      let url = "apk/download";

      // Mostrar loader mientras se procesa la descarga
      Swal.fire({
        title: "Descargando aplicación",
        html: "Por favor espere un momento mientras se descarga el archivo...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const response = await axios.get(url, { responseType: "blob" });

        // Cerrar loader
        Swal.close();

        // Si la respuesta es JSON o HTML (por ejemplo un mensaje de error o enlace)
        if (response.data && (response.data.type === "application/json" || response.data.type === "text/html")) {
          const text = await response.data.text();
          try {
            const res = JSON.parse(text);
            if (res.url || res.download_url) {
              window.location.href = res.url || res.download_url;
              return;
            }
            Swal.fire({
              icon: (res.status || res.exito) ? "info" : "error",
              title: (res.status || res.exito) ? "Información" : "Error",
              text: res.message || res.mensaje || "No se pudo procesar la descarga del APK.",
            });
            return;
          } catch (e) {
            console.error("Error al parsear respuesta de error:", e);
          }
        }

        const fileName = nombreapk || state.Download?.nombreapk || "tiresoft-production.apk";
        const blob = new Blob([response.data], {
          type: response.headers["content-type"] || "application/vnd.android.package-archive"
        });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        // Diferir la eliminación y revocación del Blob URL para evitar que el navegador cancele la descarga
        setTimeout(() => {
          link.remove();
          window.URL.revokeObjectURL(blobUrl);
        }, 1000);
      } catch (error) {
        Swal.close();
        console.error("Error al descargar el APK:", error);
        Swal.fire({
          icon: "error",
          title: "Error de descarga",
          text: "Ocurrió un error al descargar la aplicación desde el servidor.",
        });
      } finally {
        commit("SetIsDownloading", false);
      }
    },
  }
};

